import axios from 'axios';

export const FETCH_MTO_DETAILS_BEGIN = 'FETCH_MTO_DETAILS_BEGIN';
export const FETCH_MTO_DETAILS_SUCCESS = 'FETCH_MTO_DETAILS_SUCCESS';
export const FETCH_MTO_DETAILS_FAILURE = 'FETCH_MTO_DETAILS_FAILURE';

export const fetchMtoCertificateDetailsBegin = () => ({
    type: FETCH_MTO_DETAILS_BEGIN
});

export const fetchMtoCertificateDetailsSuccess  = (value) => ({
    type: FETCH_MTO_DETAILS_SUCCESS,
    payload: value
});

export const fetchMtoCertificateDetailsFailure = (error) => ({
    type: FETCH_MTO_DETAILS_FAILURE,
    payload: error
});

export const getMtoCertificateDetails = (webappurlForms, accessToken, organisationArn) => {
    return dispatch => {
        const options = {
            headers: {
                'Authorization': "Bearer " + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        dispatch(fetchMtoCertificateDetailsBegin());
        //TODO: FIX url to point to dev environment once API is deployed
        return axios.post(webappurlForms + `/api/myCASA/Forms/GetMTOCertificate/${organisationArn}/v1`, null, options)
            .then(response => {
                if (response.data?.wasSuccessful && response?.data?.maintenanceTrainingOrganisation?.certificate) {
                    return dispatch(fetchMtoCertificateDetailsSuccess(response.data.maintenanceTrainingOrganisation.certificate));
                }
                else {
                    return dispatch(fetchMtoCertificateDetailsFailure(response.data.errors));
                }
            })
            .catch(error => {
                return dispatch(fetchMtoCertificateDetailsFailure(error.response ? error.response.data.errors : error));
            });
    }
}
